// Network logs record XHR bodies when the Gleap project turns them on; keep the
// one-time enrollment token and code (the create responses carry them in plain)
// and the device agent out of them.
export const GLEAP_NETWORK_BLACKLIST = [
  '/Fleet/EnrollmentTokens',
  '/Fleet/EnrollmentCodes',
  '/Agent/',
];
